module.exports = __webpack_public_path__ + "static/media/silestone-white.4c4d9c7b.svg";